import { useTranslation } from "react-i18next";
import Lottie from "lottie-react";
import TransactionCompleteAnim from "../../utils/pendincAnimation.json";

const Nuvei = () => {
  const { t } = useTranslation();

  return (
    <div className="flex justify-center items-center flex-col gap-1  h-full">
      <div className="h-[100px] w-[100px] bg-[#FFA500] rounded-[50%] flex justify-center items-center">
        <Lottie
          animationData={TransactionCompleteAnim}
          style={{ width: "55px", height: "55px" }}
        />
      </div>
      <p className="text-[20px] text-[#170738] mt-[20px]">
        {t("pending.paymentProcessing")}
      </p>
      <div style={{ transform: "translateY(-30px)", marginTop: "20px" }}>
        <p className="opacity-50 text-center whitespace-pre-line">
          {t("pending.takeFewSecond")}
        </p>
      </div>
    </div>
  );
};

export default Nuvei;
